﻿
import { _shared_xfunc } from '../js/shared/_shared_xfunc.js';


export class LoginPage {

    constructor() {

        let me = this;
        me.FailedPasswordAttemptCount = 0;

        if (topiccode == '')
            topiccode = 'MLB';

        $('#login-topiccode').val(topiccode);

        if (mode == '')
            mode = 'pregame';

        $('#login-mode').val(mode);

        const Toast_Login = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        });

        $("#loginform").validate({
            rules: {
                "login-username": {
                    required: true
                },
                "login-password": {
                    required: true
                }
            },
            messages: {
                "login-username": {
                    required: "Please enter Username"
                },
                "login-password": {
                    required: "Please enter password"
                }
            },
            submitHandler: function (form) {

                if ($('#login-username').val() === '' || $('#login-password').val() === '') {
                    Toast_Login.fire({
                        icon: 'error',
                        title: 'Please enter username and password'
                    });
                    $('.form').effect('highlight', {}, 3000);
                }
                else {

                    var data = {};
                    var token = $('input[name="__RequestVerificationToken"]').val();
                    data.username = $("#login-username").val();
                    data.password = $("#login-password").val();
                    data.topiccode = $("#login-topiccode").val();
                    data.mode = $("#login-mode").val();
                    data.__RequestVerificationToken = token;

                    var $btnLogin = $('#btn-login');
                    $($btnLogin).prop("disabled", true);
                    $($btnLogin).html(
                        '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Logging in...'
                    );

                    let _cbLogin = function (data) {
                        if (data.succeeded) {
                            me.FailedPasswordAttemptCount = 0;
                            window.location.href = window.location.origin + "/Home/Index?" + $.param({ 'topiccode': data.topiccode, 'mode': data.mode });
                        }
                        else {
                            me.FailedPasswordAttemptCount++;

                            if (me.FailedPasswordAttemptCount >= 5) {
                                Swal.fire({
                                    title: "",
                                    html: '<p>It looks like you may have forgotten your username or password.  Please contact someone from your team who can help, or email us at <a href= "mailto: support@inside-edge.com"> support@inside-edge.com </a> for assistance.</p>',
                                    icon: "error"
                                });
                            }

                            $($btnLogin).prop("disabled", false);
                            $($btnLogin).html(
                                'Login'
                            );
                            $('.field-validation-valid').html(`<span class="text-danger">${data.message}</span>`);
                        }
                    };

                    _shared_xfunc.DoAjaxPost("/Account/Login",
                        2,
                        data,
                        _cbLogin
                    );

                }
            }
        });


    }

}

